var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.75 17.375C40.75 15.7578 39.8359 14.2812 38.5 13.5078V2.82031C38.5 2.1875 38.0078 0.5 36.25 0.5C35.6875 0.5 35.1953 0.710938 34.8438 1.0625L28.7969 5.84375C25.8438 8.23438 22.0469 9.5 18.25 9.5H4.75C2.21875 9.5 0.25 11.5391 0.25 14V20.75C0.25 23.2812 2.21875 25.25 4.75 25.25H7.07031C7 26.0234 6.92969 26.7969 6.92969 27.5C6.92969 30.3125 7.5625 32.9844 8.75781 35.3047C9.10938 36.0781 9.88281 36.5 10.7266 36.5H15.9297C17.7578 36.5 18.8828 34.4609 17.7578 32.9844C16.6328 31.4375 15.9297 29.6094 15.9297 27.5C15.9297 26.7266 16.0703 26.0234 16.2109 25.25H18.25C22.0469 25.25 25.8438 26.5859 28.7969 28.9766L34.8438 33.7578C35.1953 34.1094 35.6875 34.25 36.1797 34.25C37.9375 34.25 38.4297 32.7031 38.4297 32V21.3125C39.8359 20.5391 40.75 19.0625 40.75 17.375ZM34 27.3594L31.6094 25.4609C27.8125 22.4375 23.1016 20.75 18.25 20.75V14C23.1016 14 27.8125 12.3828 31.6094 9.35938L34 7.46094V27.3594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.b8c1cb4fe974df9cb9a5770b7bb0456f.svg";
export { ForwardRef as ReactComponent };